import { Button, Tooltip } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useFormikContext } from 'formik';
import React, { useCallback, useMemo } from 'react';
import { useObservable } from 'react-use-observable';
import salesService from 'v2/services/sales/general';
import subscriptionsService from 'v2/services/subscriptions';

import AdvancedButton from '../AdvancedButton';
import { DateTypes, initialFilter, PaymentTypes } from '../interfaces';
import Item from './item';

import type { ISubscriptionsFilter } from '../interfaces';

const useStyle = makeStyles((theme) => ({
  root: {},
  title: {
    fontSize: '2rem',
    lineHeight: 1,
    fontWeight: 200,
    display: '1',
    '& p': {
      fontSize: '1.2rem',
      fontWeight: 400,
      lineHeight: '1.3125rem',
      marginBottom: theme.spacing(2),
      width: '100%',
    },
  },
  result: {
    //color: '#596375',
    border: '2px dashed #596375',
    background: 'white',
    borderRadius: 4,
    padding: theme.spacing(2),
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    cursor: 'pointer',
  },
  tags: {
    cursor: 'pointer',
    display: '1',
    width: '90%',
    '&:hover': {
      opacity: '80%',
    },
  },
  buttonReset: {
    display: '2',
    width: '10%',
  },
  tooltip: {
    cursor: 'pointer',
  },
}));

const ResultFilter = () => {
  const { resetForm } = useFormikContext<ISubscriptionsFilter>();
  const classes = useStyle({});

  const [filter] = useObservable(() => subscriptionsService.getFilter(), []);
  const [contractStatus] = useObservable(() => subscriptionsService.getStatus(), []);

  const onOpenAdvanced = useCallback(() => {
    subscriptionsService.setFilterIsAdvanced(true);
  }, []);

  const [products] = useObservable(() => {
    return subscriptionsService.getProducts();
  }, []);

  const [affiliates] = useObservable(() => {
    return salesService.getAffiliates();
  }, []);

  const resetFilter = useCallback(() => {
    subscriptionsService.setFilter(initialFilter);
    resetForm({ values: initialFilter });
    const np = products.map((prod) => {
      prod.checked = false;
      return prod;
    });
    subscriptionsService.setProducts(np);
  }, [products, resetForm]);

  const productsFormated = useMemo(
    () => products?.filter((prod) => prod.checked).map((p) => ({ label: `${p.id} - ${p.title}`, value: p.id })),
    [products]
  );

  return (
    <div className={classes.root}>
      <span className={classes.title}>
        <p>Filtros Aplicados</p>
      </span>

      <div className={classes.result}>
        {filter && (
          <Tooltip className={classes.tooltip} title='Clique para editar os filtros'>
            <div className={classes.tags} onClick={onOpenAdvanced}>
              <Item label={'Tipo de data'} value={filter.date_type} alias={DateTypes}></Item>
              <Item label={'Data'} value={`${filter.date[0]} ~ ${filter.date[1]}`}></Item>
              {filter.customer && (
                <>
                  <Item label={'Cliente'} value={filter.customer}></Item>
                </>
              )}
              <Item label={'Fatura'} value={filter.invoice_id}></Item>
              <Item label={'Contrato'} value={filter.id}></Item>
              <Item label={'Tipo de pagamento'} value={filter.payment_method} alias={PaymentTypes}></Item>
              <Item label={'Status da fatura'} value={filter.status} alias={contractStatus}></Item>
              <Item label={'Produto'} value={filter.product_id} alias={productsFormated}></Item>
              <Item label={'Afiliado'} value={filter.affiliate_id} alias={affiliates}></Item>
              <Item label={'Filtro específico'} value={filter.negotiated_invoices ? 'Contratos com faturas negociadas' : null}></Item>
              <Item label={'Filtro específico'} value={filter.open_invoices ? 'Contratos com fatura em aberto (além da vigente)' : null}></Item>
            </div>
          </Tooltip>
        )}
        <div className={classes.buttonReset}>
          <Button fullWidth onClick={resetFilter}>
            X Limpar
          </Button>
        </div>
      </div>
      <AdvancedButton />
    </div>
  );
};
export default ResultFilter;
